import React from "react";
import { motion } from "framer-motion";
import { SlidersHorizontal, Trash2 } from "lucide-react";
import MemberAvatar from "./MemberAvatar";

const ShopTeamMember = ({ member, type, onRemove, onEdit }) => {
  return (
    <motion.article
      className="shop-team-member"
      key={member.id}
      layout
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: -12 }}
      transition={{ duration: 0.24, ease: "easeOut" }}
    >
      <MemberAvatar src={member.imageUrl} alt={`${member.name} avatar`} />
      <div className="shop-team-member-copy">
        <div className="shop-team-name-line">
          <h3>{member.name}</h3>
          <span className="shop-role-chip">{member.role}</span>
        </div>
        <p>{member.email || "Accepted team member"}</p>
      </div>
      <div className="shop-team-member-actions" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        {typeof onEdit === "function" && (
          <button
            type="button"
            className="shop-member-edit"
            style={{
              background: "none",
              border: "none",
              color: "#6b7280",
              cursor: "pointer",
              padding: "6px",
              borderRadius: "6px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            aria-label={`Manage access for ${member.name}`}
            title="Manage access"
            onClick={() => onEdit(member)}
          >
            <SlidersHorizontal size={16} />
          </button>
        )}
        <button
          type="button"
          className="shop-member-remove"
          aria-label={`Remove ${member.name}`}
          onClick={() => onRemove(type, member.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
    </motion.article>
  );
};

export default ShopTeamMember;
